export default function (middlewareList) {
    return function (ctx, next) {
        let index = -1;
        const dispatch = function (i) {
            if (i <= index) {
                return Promise.reject(new Error("next() called multiple times"));
            }
            index = i;
            let fn = middlewareList[i];
            if (i === middlewareList.length) {
                fn = next;
            }
            if (!fn) {
                return Promise.resolve(ctx);
            }
            else {
                return Promise.resolve(fn(ctx, fn === next ? undefined : dispatch.bind(null, i + 1)));
            }
        };
        return dispatch(0);
    };
}
